export default `/* Ids Icon Component */
:host {
  display: inline-flex;
  align-self: center;
  contain: content;
  place-self: center;
  position: relative;
}

svg {
  color: var(--ids-icon-color-default);
  height: var(--ids-icon-height-default);
  width: var(--ids-icon-width-default);
}

:host([hidden]) {
  display: none;
}

.mirrored {
  transform: scaleX(-1);
}

:host([icon=more]) svg,
:host([icon=vertical-ellipsis]) svg {
  height: 19px;
}

:host([icon=add]) svg {
  width: 17px;
}

:host([icon=logo]) svg path:nth-child(1) {
  display: none;
}

:host([compact=true]) svg {
  height: calc(var(--ids-button-icon-compact-height) - 2px);
  width: calc(var(--ids-button-icon-compact-width) - 2px);
}

:host([icon=favicon]) {
  color: var(--ids-icon-infor-color);
}
:host([icon=favicon]) path:nth-child(2) {
  fill: white;
}

:host([icon=genai]) .insights-stop-1 {
  stop-color: var(--ids-button-ai-color-icon-primary);
}
:host([icon=genai]) .insights-stop-2 {
  stop-color: var(--ids-button-ai-color-icon-secondary);
}

:host(.editor-forecolor) .stop-underline,
:host(.editor-forecolor) .stop-base {
  stop-color: var(--ids-button-formatter-color-text-default);
}

:host(.editor-forecolor.is-active) .stop-underline {
  stop-color: var(--forecolor-active-color);
}

.notification-badge {
  background-color: var(--ids-notification-badge-error-color-background);
  border-radius: var(--ids-notification-badge-border-radius);
  height: var(--ids-notification-badge-size);
  width: var(--ids-notification-badge-size);
  position: absolute;
}
.notification-badge.info, .notification-badge.base {
  background-color: var(--ids-notification-badge-info-color-background);
}
.notification-badge.error {
  background-color: var(--ids-notification-badge-error-color-background);
}
.notification-badge.success {
  background-color: var(--ids-notification-badge-success-color-background);
}
.notification-badge.warning {
  background-color: var(--ids-notification-badge-warning-color-background);
}
.notification-badge {
  /**
  * positioning notification badge
  */
}
.notification-badge.top-right {
  bottom: calc(100% - var(--ids-notification-badge-size));
  left: calc(100% - var(--ids-notification-badge-size));
}
.notification-badge.top-left {
  bottom: calc(100% - var(--ids-notification-badge-size));
  left: 0;
}
.notification-badge.bottom-right {
  bottom: 0;
  left: calc(100% - var(--ids-notification-badge-size));
}
.notification-badge.bottom-left {
  bottom: 0;
  left: 0;
}

:host([disabled]) .notification-badge {
  background-color: var(--ids-alert-color-error-disabled);
}
:host([disabled]) .notification-badge.info, :host([disabled]) .notification-badge.base {
  background-color: var(--ids-alert-color-info-disabled);
}
:host([disabled]) .notification-badge.error {
  background-color: var(--ids-alert-color-error-disabled);
}
:host([disabled]) .notification-badge.success {
  background-color: var(--ids-alert-color-success-disabled);
}
:host([disabled]) .notification-badge.warning {
  background-color: var(--ids-alert-color-warning-disabled);
}

[class^=status-color] {
  background-color: var(--ids-icon-status-color-blue-color-background);
  color: var(--ids-icon-status-color-blue-color-text);
  border-radius: var(--ids-icon-status-color-border-radius);
  padding: var(--ids-icon-status-color-padding);
  overflow: visible;
}

.status-color-red {
  background-color: var(--ids-icon-status-color-red-color-background);
  color: var(--ids-icon-status-color-red-color-text);
}

.status-color-orange {
  background-color: var(--ids-icon-status-color-orange-color-background);
  color: var(--ids-icon-status-color-orange-color-text);
}

.status-color-green {
  background-color: var(--ids-icon-status-color-green-color-background);
  color: var(--ids-icon-status-color-green-color-text);
}

.status-color-blue {
  background-color: var(--ids-icon-status-color-blue-color-background);
  color: var(--ids-icon-status-color-blue-color-text);
}

.status-color-teal {
  background-color: var(--ids-icon-status-color-teal-color-background);
  color: var(--ids-icon-status-color-teal-color-text);
}

.status-color-purple {
  background-color: var(--ids-icon-status-color-purple-color-background);
  color: var(--ids-icon-status-color-purple-color-text);
}

.status-color-gray {
  background-color: var(--ids-icon-status-color-neutral-color-background);
  color: var(--ids-icon-status-color-neutral-color-text);
}

.status-color-yellow {
  background-color: var(--ids-icon-status-color-yellow-color-background);
  color: var(--ids-icon-status-color-yellow-color-text);
}

.status-color-error {
  background-color: var(--ids-icon-status-color-error-color-background);
  color: var(--ids-icon-status-color-error-color-text);
}

.status-color-warning {
  background-color: var(--ids-icon-status-color-warning-color-background);
  color: var(--ids-icon-status-color-warning-color-text);
}

.status-color-alert {
  background-color: var(--ids-icon-status-color-alert-color-background);
  color: var(--ids-icon-status-color-alert-color-text);
}

.status-color-info {
  background-color: var(--ids-icon-status-color-info-color-background);
  color: var(--ids-icon-status-color-info-color-text);
}

.status-color-success {
  background-color: var(--ids-icon-status-color-success-color-background);
  color: var(--ids-icon-status-color-success-color-text);
}

.status-color-caution {
  background-color: var(--ids-icon-status-color-caution-color-background);
  color: var(--ids-icon-status-color-caution-color-text);
}

:host(.calendar-event-header-icon) svg {
  background-color: var(--ids-color-transparent) !important;
}

[fill="#7928E1"] {
  color: transparent;
  fill: var(--ids-button-ai-sparkle-icon-color-fill);
}

[fill="#161618"] {
  fill: currentColor;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
